import { render, staticRenderFns } from "./PTTGC_2.vue?vue&type=template&id=29b4f2fa&"
import script from "./PTTGC_2.vue?vue&type=script&lang=js&"
export * from "./PTTGC_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('29b4f2fa', component.options)
    } else {
      api.reload('29b4f2fa', component.options)
    }
    module.hot.accept("./PTTGC_2.vue?vue&type=template&id=29b4f2fa&", function () {
      api.rerender('29b4f2fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/request/extend/PTTGC_2.vue"
export default component.exports